module.exports = __webpack_public_path__ + "img/store_amanata.e140f1af.png";